import React from 'react'
import PropTypes from 'prop-types'

import Titlebar from 'core/components/Titlebar'
import ConversationListItem from './ConversationListItem'

const ConversationList = props => {
  return (
    <div className="conversation-list">
      {props.titlebar && <Titlebar {...props.titlebar} />}
      {!props.loading && props.data.length === 0 ? (
        <p className="conversation-empty type-body mod-sm-body">No conversations right now.</p>
      ) : (
        <ul className="conversation-list-list">
          {props.data.map((item, i) => {
            return <ConversationListItem {...props} key={i} item={item} />
          })}
        </ul>
      )}
    </div>
  )
}

ConversationList.propTypes = {
  data: PropTypes.array.isRequired,
  titlebar: PropTypes.object,
  handleSelect: PropTypes.func.isRequired,
  conversation: PropTypes.object,
  loading: PropTypes.bool
}

export default ConversationList
